<template>
  <div class="flex justify-center items-center">
    <div
      id="container"
      class="flex h-full items-stretch overflow-x-scroll relative"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent, watch, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Carousel',
  props: {
    scrollTo: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const scrollToChild = computed(() => props.scrollTo);

    watch(scrollToChild, (newVal) => {
      const container = document?.querySelector('#container');

      const containerMiddle = container?.offsetWidth / 2;

      container?.scrollTo({
        top: 0,
        left: newVal - containerMiddle + 155,
        behavior: 'smooth',
      });
    });
  },
});
</script>
<style scoped>
html {
  scroll-behavior: smooth;
}
</style>
